module.exports = __webpack_public_path__ + "img/medical.e53085c7.svg";